export default {

	namespaced: true,

	state: {
		messages: [],
	},

	
	getters: {
		currentMessage(state):string {
			return state.messages.length > 0 ? state.messages[0] : "";
		}
	},

	mutations: {
		addMessage(state, message:string):void {
			state.messages.push(message);
		},

		popMessage(state) {
			state.messages.shift();
		}
	},
}